namespace $.$$ {

	$mol_style_define( $bog_vmap_app_menu, {
		position: 'absolute',

		List: {
			minWidth: '14rem',
			padding: { top: $mol_gap.space, bottom: $mol_gap.space },
		},

	} )

}
